﻿window.cObjetReservationCommandeMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Commande"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvelle commande"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data == 'undefined' && objet.data == null) { txt = "Hébergement" }
        else {
            txt = objet.data.nom
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-barcode'></i>");
    }

    this.mGetRadiusImage = function () { return "50%" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetDataArticle = function () {
        return objet.bddRef.mGetArray("article").filter(function (o) { return o.id_article == objet.data.id_article })[0]
    }

    this.mGetLibHtml = function () {
        var formatDa = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
        var libHtml = (objet.data.date_service ? objet.data.date_service.dayOfWeekName() + " " + formatDa(objet.data.date_service) : "")
        switch (parseInt(objet.data.id_type_iteration_service)) {
            case 0: break;
            case 1: libHtml += "&bull;Matin"; break;
            case 2: libHtml += "&bull;Midi"; break;
            case 3: libHtml += "&bull;Soir"; break;
        }
        libHtml += " &bull; " + objet.data.qte + " × " + parseFloat(objet.data.puttc).formatDisplay() + "€ = <span style='font-weight:600;'>" + this.mGetTotTtc().formatDisplay() + "€</span>"
        return libHtml
    }

    this.mGetReservation = function () {
        return Me.objet.bddRef.mGetArray("reservation").filter(function (o) { return o.id_reservation == objet.data.id_reservation })[0]
    }

    this.mGetTotTtc = function () {
        return objet.data.qte * objet.data.puttc
    }

    this.mGetGenereDocCptLigne = function () {
        var article = this.mGetDataArticle()
        var objArticle = Me.objet.bddRef.getObjet(article)
        var dataLigne = Me.objet.bddRef.getObjet("doc_cpt_ligne").mGetNewData()
        dataLigne.note = ""
        dataLigne.nom_article = ((article.nom == null) ? "" : article.nom) + " <span style='font-size:80%;'>(" + this.mGetLibHtml() + ")</span>"
        dataLigne.id_article = article.id_article
        dataLigne.qte = objet.data.qte
        dataLigne.date_service = objet.data.date_service

        dataLigne.id_tva = Me.objet.bddRef.getObjet("tva").objetMetier.mGetTvaTaux0().id_tva
        var tauxTva = 0
        if (Me.objet.bddRef.mGetArray("societe")[0].assujetti_tva == "1") {
            var dataTva = objArticle.objetMetier.mGetDataTva()
            if (typeof dataTva != 'undefined') {
                if (Me.objet.bddRef.mGetArray("societe")[0].assujetti_tva == "1") {
                    dataLigne.id_tva = dataTva.id_tva
                    tauxTva = Me.objet.bddRef.getObjet(dataTva).objetMetier.mGetTauxTva()
                }
            }
        }
        dataLigne.puht = Me.mGetTotTtc(objet.data.date_service)
        dataLigne.puttc = Me.mGetTotTtc(objet.data.date_service)
        if (tauxTva != 0) dataLigne.puht = Math.round(dataLigne.puht / (1 + tauxTva / 100) * 100) / 100
        dataLigne.type_remise = 0


        return dataLigne
    }

}